import { useApolloClient } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import { MapEditorEcologicalFunctionPanel } from "~/modules/mapEditor/components/MapEditorEcologicalFunctionPanel";
import { ObservationCardFragment } from "~/modules/mapEditor/components/ObservationCard/fragments.generated";

import { ProjectReviewVisitV2Screen_GetDataDocument } from "../../../../queries.generated";

interface ProjectReviewVisitV2FunctionDetailRouteProps {
    backHref: string;
}

export function ProjectReviewVisitV2FunctionDetailRoute({ backHref }: ProjectReviewVisitV2FunctionDetailRouteProps) {
    const { t } = useTranslation("project");
    const { mapEditorFeatureId } = useParams();
    const client = useApolloClient();

    if (!mapEditorFeatureId) {
        throw new Error("Parameter `mapEditorFeatureId` is required");
    }

    const createLinkToObservation = (element: ObservationCardFragment) => {
        return `observations/${element.featureId}`;
    };

    const handleAfterDelete = async () => {
        await client.refetchQueries({ include: [ProjectReviewVisitV2Screen_GetDataDocument] });
    };

    return (
        <MapEditorEcologicalFunctionPanel
            backHref={backHref}
            createHrefToObservation={createLinkToObservation}
            mapEditorFeatureId={mapEditorFeatureId}
            onEcologicalFunctionDeleted={handleAfterDelete}
            readonly={false}
            title={t("projectReviewVisitV2.functionsRoute.functionDetailTitle")}
        />
    );
}
